export default "__VITE_ASSET__44066e6c__"